import { useClientConfig } from '@workspace/public-utils'

export default function BrandMark({ className = '' }: { className?: string }) {
  const { brandName } = useClientConfig()
  return (
    <span className={`md-brand-mark ${className}`}>
      <span className="sr-only">{brandName}</span>
      <span className="md-brand-prefix" aria-hidden="true">
        로또
      </span>
      <img src="/brand/myungdang.svg" width="246" height="142" alt="" aria-hidden="true" />
    </span>
  )
}
